<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <!-- Title -->
                <p v-if="baseCategory && baseCategory.names"><b>{{ $t('categoryIntro') }}</b> {{baseCategory.names[currentLanguage.key]}}</p>
                <!-- Language dropdown -->
                <LanguageDropdown class="align-self-end" v-model="currentLanguage"></LanguageDropdown>
                <!-- Name -->
                <div>
                    <div role="group" class="form-group">
                        <label class=""> {{ $t('nameMandatory') }}</label>
                        <CInput type="text" v-model="category.names[currentLanguage.key]" :invalid-feedback="errorOutput['Name']" :is-valid="nameValidator() && errorValidator('Name')"></CInput>
                    </div>
                </div>
                <!-- Types -->
                <div role="group" class="form-group" v-bind:class="{'disabled': $route.params.type || baseCategory}">
                    <label class=""> {{ $t('typeMandatory') }}</label>
                    <SingleOptionDropdown v-model="category.type" :options="types" :title="$t('type')" :index="1" :is-valid="typeValidator() && errorValidator('Type')" :invalid-feedback="errorOutput['Type']"></SingleOptionDropdown>
                </div>
                <!-- Action button + loading -->  
                <CSpinner v-if="loading" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary col-2 align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { deepClone } from "@/helpers/utils.js";
import Category from "@/classes/Category";
import { mapState } from 'vuex'
import LanguageDropdown from '../controls/LanguageDropdown.vue'
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/views/controls/popups/ConfirmationPopUp.vue";
import SingleOptionDropdown from '../controls/SingleOptionDropdown.vue'

const TYPE_PRODUCT = "Product";
const TYPE_POI = "Poi";

  export default {
  components: { LanguageDropdown, ConfirmationPopUp, SingleOptionDropdown },
    props:{    
        baseCategory:
        {
            type: Object,
            default: null,
        }
    },
    data()
    {
        return {
            submitted: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            category: new Category({}),
            loading: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            //
            types: [{label: this.$t("product"), key: TYPE_PRODUCT}, {label: this.$t("poi"), key: TYPE_POI}]
        }
    },
    mounted: function()
    {
        this.resetCategory();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate Name
            for (const [key, value] of Object.entries(this.category.names)) {
                if(!value)
                {
                    result['Name'] = this.$i18n.t("validateBothTranslations");
                    break;
                };
            }

            return result;
        },
        ...mapState('categories', ['processTask']),
    },
    methods:{
        resetCategory(){
            if(!this.baseCategory)
            {
                var names = {};
                CONSTANTS.supportedLanguages.forEach(language => names[language.key] = "");

                this.category = new Category(names, this.$route.params.type);
            }
            else
            {
                this.category = deepClone(new Category, this.baseCategory);          
            }
        },
        submitClicked(){
            this.submitted = true;
            // Emit event
            if(this.category.isValid())
            {
                this.loading = true;
                this.$emit('submit-requested', this.category);
            }
        },
        nameValidator(){
            var result = undefined;

            if(this.submitted)
            {
                // Validate all fields
                for (const [key, value] of Object.entries(this.category.names)) {
                    if(!value)
                    {
                        result = false;
                        break;
                    };
                }
                
                if(result == undefined)
                {
                    result = true;
                }
            }

            return result;
        },
        errorValidator(fieldName)
        {
            var result = undefined;

            if(this.alertOutput && Array.isArray(this.alertOutput)) // Error alertOutput
            {
                if(this.alertOutput.find(obj => {
                    return obj.key === fieldName
                }))
                {
                    result = false;
                }
            }

            return result;
        },
        typeValidator(){
            var result = undefined;

            if(this.submitted && !this.category.type)
            {
                result = false;
            }

            return result;
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "ListCategories", params: { type: this.$route.params.type } });
        },
    },
    watch:
    {
        processTask: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseCategory: function()
        {
            this.resetCategory();
        },
        alertType: function()
        {
            this.loading = false;
        },
        alertOutput: function()
        {
            this.loading = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

    .showDropdown
    {
        display: block !important;
    }

    .input-group-append
    {
      height: fit-content;
    }

    img
    {
        width: 50%;
        height: 50%;
    }

</style> 